import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-ssoRequireAccountSetUpWarning',
  templateUrl: './ssoRequireAccountSetUpWarning.component.html'
})
export class SsoRequireAccountSetUpWarningComponent {
  @Input()
  public ssoSource: string = '';
  @Input()
  public username: string = '';
  // constructor(){}
  constructor(@Inject(MAT_DIALOG_DATA) public data: {ssoSource: string, username: string}) {
    this.ssoSource = data.ssoSource;
    this.username = data.username;
  }
}
